<template>
    <emp-component-modal :is-active="isActive" modal-class="inventory-form" @modal:close="onClose">
        <div slot="modal-header">{{ title }}</div>
        <div slot="modal-body">
            <div class="columns is-multiline">
                <div class="column is-full">
                    <p>{{ message }}</p>
                </div>

                <div class="column is-full" v-if="description">
                    <p>{{ description }}</p>
                </div>

                <div class="level column is-full">
                    <div class="level-right">
                        <div class="level-item">
                            <confirmation-button :label="confirmLabel" @click="onConfirm" :buttonClass="confirmClass" />
                        </div>
                        <div class="level-item">
                            <emp-button
                                role="cancel"
                                :label="cancelLabel"
                                @click="onCancel"
                                :buttonClass="cancelClass"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </emp-component-modal>
</template>

<script>
import ConfirmationButton from '@/components/shared/elements/ConfirmationButton';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        ConfirmationButton,
    },
    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        ...mapActions('shared/modal', ['closeModal']),
        async onConfirm() {
            this.callback();
            this.onClose();
        },
        onClose() {
            this.closeModal();
            this.$emit('onClose');
        },
    },
    computed: {
        ...mapState({
            modalData: (state) => state.shared.modal.data,
        }),

        title() {
            return this.modalData?.title ?? 'Confirm';
        },
        message() {
            return this.modalData?.message ?? 'Are you sure?';
        },
        description() {
            return this.modalData?.description ?? '';
        },
        confirmLabel() {
            return this.modalData?.confirmLabel ?? 'Confirm';
        },
        cancelLabel() {
            return this.modalData?.cancelLabel ?? 'Cancel';
        },
        onCancel() {
            return this.modalData?.onCancel ?? this.onClose;
        },
        confirmClass() {
            return this.modalData?.confirmClass ?? 'is-success';
        },
        cancelClass() {
            return this.modalData?.cancelClass ?? 'is-danger';
        },
        callback() {
            if (this.modalData) {
                return this.modalData.callback;
            }
        },
    },
};
</script>
